module.exports = __webpack_public_path__ + "static/media/BannerDisplayHrefsExample@1x.948c54b7558898d2e1e74193139a9a93.jpg";